import React, { useMemo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import utils from "../../../utils/utils";
import { formatQuizDueDateForApi } from "./qmsPublishReviewNotificationUtils";

function startOfToday() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

function QmsReviewDueDatePicker({
  value = "",
  onChange,
  disabled = false,
  id = "qms-publish-review-due-date",
  inline = false,
}) {
  const minDate = useMemo(() => startOfToday(), []);
  const selectedDate = useMemo(() => utils.parseDateInput(value), [value]);

  return (
    <div
      className={`qms-publish-review-date${
        inline ? " qms-publish-review-date--inline" : ""
      }`}
    >
      <label className="qms-publish-review-date__label" htmlFor={id}>
        Review due <span className="text-danger">*</span>
      </label>
      <DatePicker
        id={id}
        selected={selectedDate}
        onChange={(date) => onChange?.(date ? formatQuizDueDateForApi(date) : "")}
        minDate={minDate}
        className="form-control form-control-sm qms-publish-review-date__input"
        dateFormat="dd-MM-yyyy"
        placeholderText="dd-mm-yyyy"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        disabled={disabled}
        isClearable
        autoComplete="off"
      />
    </div>
  );
}

export default QmsReviewDueDatePicker;
